import { SiloIncentivesController, SiloIncentivesController__factory } from '@silo/typechain';
import { ChecksumAddress, ClientProvider } from '@silo/types';
import { useSiloWeb3 } from '@silo/web3';
import { QueryFunction, useQuery } from '@tanstack/react-query';
import { ethers } from 'ethers';

export const totalRewardsBalanceKey = 'totalRewardsBalance';

type TotalRewardsBalanceKey = [
  key: typeof totalRewardsBalanceKey,
  clientProvider: ClientProvider,
  account: ChecksumAddress,
  siloIncentivesControllerAddress: ChecksumAddress,
  shareTokenAddresses: ChecksumAddress[]
];

export const useQueryTotalRewardsBalance = (
  shareTokenAddresses: ChecksumAddress[],
  siloIncentivesControllerAddress: ChecksumAddress | undefined
) => {
  const { clientProvider, account } = useSiloWeb3();

  return useQuery({
    queryKey: ['totalRewardsBalance', clientProvider!, account!, siloIncentivesControllerAddress!, shareTokenAddresses],
    queryFn: queryTotalRewardsBalance,
    enabled: !!clientProvider && !!account && !!siloIncentivesControllerAddress,
  });
};

const queryTotalRewardsBalance: QueryFunction<bigint, TotalRewardsBalanceKey> = async ({
  queryKey: [, clientProvider, account, siloIncentivesControllerAddress, shareTokenAddresses],
}) => {
  const SiloIncentivesControllerContract = <SiloIncentivesController>(
    new ethers.Contract(siloIncentivesControllerAddress, SiloIncentivesController__factory.abi, clientProvider)
  );

  const balance = await SiloIncentivesControllerContract.getRewardsBalance(shareTokenAddresses, account);

  return balance.toBigInt();
};
